
import React from 'react';
import { Button } from "@/components/ui/button";
import { Check, X, Trash2, Import } from "lucide-react";

type ModelObj = {
  model_id: number;
  maker_id: number;
  name: string;
  market?: string;
  adObj?: any;
  atpObj?: any;
  masterObj?: any;
};

interface ModelRowProps {
  model: ModelObj;
  masterPresent: boolean;
  adPresent: boolean;
  atpPresent: boolean;
  onImport: (model: any) => void;
  onRemove: (modelId: number, market: string) => void;
  importSourceObj: any;
}

export const ModelRow: React.FC<ModelRowProps> = ({
  model,
  masterPresent,
  adPresent,
  atpPresent,
  onImport,
  onRemove,
  importSourceObj,
}) => {
  return (
    <tr>
      <td>{model.name}</td>
      <td>
        {masterPresent ? <Check className="text-green-500 h-5 w-5" /> : <X className="text-red-500 h-5 w-5" />}
      </td>
      <td>
        {adPresent ? <Check className="text-green-500 h-5 w-5" /> : <X className="text-red-500 h-5 w-5" />}
      </td>
      <td>
        {atpPresent ? <Check className="text-green-500 h-5 w-5" /> : <X className="text-red-500 h-5 w-5" />}
      </td>
      <td>
        {masterPresent ? (
          <Button
            variant="destructive"
            size="sm"
            onClick={() => onRemove(model.model_id, model.market!)}
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Remove
          </Button>
        ) : (
          (adPresent || atpPresent) &&
          <Button
            variant="outline"
            size="sm"
            onClick={() => onImport(importSourceObj)}
          >
            <Import className="w-4 h-4 mr-2" />
            Import
          </Button>
        )}
      </td>
    </tr>
  );
};
